// File: LMSTopicsSection.jsx
// Pure CSS | Popular Topics Cards (LMS/Education)

import { Bandage, Bomb, Braces, Code, FerrisWheel, Settings } from 'lucide-react';
import React from 'react';

const topics = [
  { icon: <Bomb size={30} color={"#222222"} />, title: 'Health And Fitness' },
  { icon: <Bandage size={30} color={"#222222"} />, title: 'Business' },
  { icon: <Braces size={30} color={"#222222"} />, title: 'Computer Science' },
  { icon: <Code size={30} color={"#222222"} />, title: 'Data Science' },
  { icon: <Settings size={30} color={"#222222"} />, title: 'Development' },
//   { icon: <FerrisWheel size={30} color={"#222222"} />, title: 'Development' },
];

export default function CategoryCard1() {
  return (<>
    <section className="lms-sec-catc-1">
      <div className="lms-header-catc-1"><div>
        <span className="cat-tag-catc-1">Categories</span>
        <h2 className="title-catc-1">Popular Topics To Learn</h2></div>
        <button className="viewAll-btn-catc-1">View All</button>
      </div>

      <div className="card-grid-catc-1">
        {topics.map((t) => (
          <div className="topic-card-catc-1" key={t.title}>
            <div className="icon-wrap-catc-1">{t.icon}</div>
            <h4>{t.title}</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </div>
        ))}
      </div>
    </section>
    <style>{`
/* File: LMSTopicsSection.css */

.lms-sec-catc-1 {
  padding: 60px 40px;
  background: #fff;
  font-family: Inter, sans-serif;
}

.lms-header-catc-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

.cat-tag-catc-1 {
  text-transform: uppercase;
  font-size: 14px;
  color: rgba(144, 202, 249,1);
  font-weight: 600;
}

.title-catc-1 {
  flex: 1;
  text-align: center;
  font-size: 30px;
  font-weight: 800;
  color: #1a1a1a;
}

.viewAll-btn-catc-1 {
  background: rgba(144, 202, 249,1);
  color: #fff;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.card-grid-catc-1 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.topic-card-catc-1 {
  background: rgba(144, 202, 249,0.1);
  padding: 26px 20px;
  border-radius: 14px;
  text-align: center;
  transition: 0.3s;
  border: 2px solid transparent;
}

.topic-card-catc-1:hover {
  border-color: rgba(144, 202, 249,1);
  transform: translateY(-4px);
}

.icon-wrap-catc-1 {
  width: 60px;
  height: 60px;
  background: #ffffff;
  color: rgba(144, 202, 249,1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin: 0 auto 12px;
}

.topic-card-catc-1 h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #000;
}

.topic-card-catc-1 p {
  font-size: 14px;
  color: #666;
}

@media(max-width:768px){
.lms-sec-catc-1 {
  padding: 60px 5px;

}
  .lms-header-catc-1 {
    flex-direction: column;
    gap: 12px;
  }
    
.card-grid-catc-1 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
}
  .title {
    text-align: center;
  }
}`}</style>
    </>
  );
}
